import { AxiosResponse } from 'axios';
import auth_ef from './ef/auth';
interface IAuth {
    loginUserService(payload: {
        username: string;
        password: string;
        clientID?: string;
        userPool?: string;
    }): Promise<AxiosResponse<any>>;
    obtainSupplementaryUserInfo(payload: { email: string }): Promise<AxiosResponse<any>>;
    jwtService(): Promise<AxiosResponse<any>>;
}

function getAuth(): IAuth {
   return auth_ef;
}

export default getAuth();
